/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsArrowTurnUpRight: {
  name: 'arrow-turn-up-right';
  data: string;
} = {
  name: 'arrow-turn-up-right',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M10.646 2.646a.5.5 0 0 1 .708 0l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.793 7.5H2a.5.5 0 0 0-.5.5v5a.5.5 0 0 1-1 0V8A1.5 1.5 0 0 1 2 6.5h11.793l-3.147-3.146a.5.5 0 0 1 0-.708Z" fill="currentColor"/></svg>`,
};
